// this file is generated by update_shopify_store_data.py at 2026-03-18 20:30:00.571467
var courses = [
    {
        "course_id": "36022C11-57BA-F011-99A1-005056A7C0C7",
        "course_version": 2,
        "name": "Springer Publishing - Emergency Nurse Certification Online Review",
        "course_type": 1,
        "author_information": "Springer Publishing",
        "description": "Prepare for the Certified Emergency Nurse (CEN\u00ae) certification exam with a comprehensive online review aligned to the latest exam outline. This course features learning modules with audio narration, knowledge check questions, and a full-length practice test to strengthen test-taking skills and boost exam-day confidence. \r\n\r\nCEN\u00ae is a registered trademark of the Board of Certification for Emergency Nursing (BCEN). The BCEN does not endorse this resource, nor does it have a proprietary relationship with Springer Publishing Company.",
        "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe key concepts and clinical knowledge areas related to emergency nursing practice and patient management.</li>\r\n    <li>Apply critical-thinking and clinical judgment skills to emergency patient-care scenarios across diverse clinical presentations.</li>\r\n    <li>Demonstrate readiness for the CEN&reg; certification exam through self-assessment activities.</li>\r\n</ul>",
        "course_outline_html": "<ul style=\"list-style-type:disc;\">\r\n    <li>Introduction</li>\r\n    <li>Cardiovascular Emergencies</li>\r\n    <li>Respiratory Emergencies</li>\r\n    <li>Neurological Emergencies</li>\r\n    <li>Gastrointestinal Emergencies</li>\r\n    <li>Genitourinary Emergencies</li>\r\n    <li>Gynecologic and Obstetrical Emergencies</li>\r\n    <li>Mental Health Emergencies</li>\r\n    <li>Medical Emergencies</li>\r\n    <li>Musculoskeletal Emergencies</li>\r\n    <li>Wound Emergencies</li>\r\n    <li>Maxillofacial Emergencies</li>\r\n    <li>Ocular Emergencies</li>\r\n    <li>Environment and Toxicology Emergencies</li>\r\n    <li>Communicable Diseases</li>\r\n    <li>Professional Issues</li>\r\n</ul>",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0E5C0830-D7C9-E511-82AF-005056B150D3",
                "course_category_name": "Patient Experience",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3C4352CA-6E88-11DB-BFA9-000423AF2167",
                "course_category_name": "Disorders and Conditions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A010654-ECD9-F011-99A4-005056A7F5E9",
                "course_category_name": "Springer Publishing - Single Courses for Purchase (NGL)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "66608656-21BB-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "27BB2B08-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Patient Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Professional Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                "course_category_name": "All Settings",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30C21A06-4DBA-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    }
];